<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 25">
    <g fill="none" fill-rule="evenodd" transform="translate(-30.642 -20)">
        <rect class="widget-icon--status" width="20.833" height="20.833" x="2.5" y="2.5" fill="#FFF" rx="3" transform="translate(31.325 20)"/>
    </g>
</svg>
